<template>
  <div class="mining home-bg">
    <div class="top-content" :style="'backgroundImage:' + backgroundImg">
      <div class="warp">
        <h2 class="page-title f-8-cl">
          <!-- 第2期超级代表投票 -->
          {{$t('vote.title1')}}{{periods}}{{$t('vote.title2')}}
        </h2>
        <p>
          {{$t('vote.startTime')}}：
          {{ startTime }} - {{ endTime }}
        </p>
      </div>
    </div>
    <div class="warp vote-content clearfix">
      <div class="vote-search clearfix a-5-bd">
        <div class="search a-5-bd clearfix">
          <input
            v-model="listfilter"
            ref="serachInp"
            class="search-input"
            type="text"
            :placeholder="$t('vote.searchText')"
          />
          <button @click="filterVote">{{$t('vote.search')}}</button>
          <b></b>
        </div>
      </div>
      <div class="vote-right" style="display:none;">
        <h5>
          <!-- 投票规则 -->
          {{$t('vote.rule')}}
        </h5>
        <div v-html="rule">
        </div>
      </div>
      <div class="table">
        <div v-if="loadingFlag && searchLoaded" class="loading-box">
          <c-loading size="50" />
        </div>
        <div class="tabel-content" v-else>
          <div class="tabel-title">
            <span style="width: 40%">
              <!-- 候选代表 -->
              {{$t('vote.info1')}}
            </span>
            <span  style="width: 40%">
              <!-- 当前得票数 -->
              {{$t('vote.info2')}}
            </span>
            <span style="width: 20%; text-align: right;">
              <!-- 操作 -->
              {{$t('vote.info3')}}
            </span>
          </div>
          <div class="tabel-list" v-if="dataList && dataList.length">
            <div class="tabel-item a-3-bd"
              v-for="(item, i) in dataList"
              :key="i"
              :style="{background: i%2 == 0 ? '#fff' : '#f0f9ff'}">
              <div class="mobile">
                <!-- <span class="b-4-cl c-5-bg">
                  {{ i + 1 }}
                </span> -->
                {{ item.account }}
                <!-- <label for="">{{ item.account }}</label> -->
              </div>
              <div class="user-num">{{ item.polls }}</div>
              <!-- <c-button
                @click="voteEvent(item)"
                :big="true"
                :disabled="voteStatus ? false : true"
                height="40px"
                width="120px"
              >
                {{ voteStatus === 0 || voteStatus === 1 ? "为他投票" : "已结束" }}
              </c-button> -->
              <div class="tabel-btn">
                <button class="vote-btn"
                 @click="voteEvent(item)"
                 :disabled="voteStatus ? false : true">
                  {{ voteStatus === 0 || voteStatus === 1
                   ? $t('vote.tabelBtn1') : $t('vote.tabelBtn2') }}
                </button>
              </div>
            </div>
          </div>
          <div class="no-data b-2-cl" v-else>
            <svg class="icon icon-50" aria-hidden="true">
              <use xlink:href="#icon-g_2"></use>
            </svg>
            <p>
              <!-- 暂无数据 -->
              {{ $t("common.notData") }}
            </p>
          </div>
        </div>
        <com-pagination
          v-if="pagination.count / pagination.pageSize > 1"
          :total="pagination.count"
          classes="vote-page"
          :current-page="pagination.page"
          :display="pagination.pageSize"
          @pagechange="pagechange"
        >
        </com-pagination>
      </div>

      <!-- 投票弹框  38-24=14 -->
      <c-dialog
        :showFlag="dialogFlag"
        paddingBottom="14px"
        :confirmLoading="dialogConfirmLoading"
        :confirmDisabled="dialogConfirmDisabled"
        @close="dialogClose"
        @confirm="dialogConfirm"
        :titleText="$t('vote.dialogTitle')"
      >
        <p class="b-2-cl">
          <!-- 确定要为 {{ uname }} 进行投票？ -->
          {{$t('vote.dialogTip1')}} {{ uname }} {{$t('vote.dialogTip2')}}
          </p>
      </c-dialog>
    </div>
  </div>
</template>
<script>
import comPagination from '@/components/comPagination.vue';
import {
  fixD, imgMap, colorMap, fixUrl, formatTime,
} from 'BlockChain-ui-privatization/utils';

export default {
  name: 'vote',
  data() {
    return {
      backgroundImg: `url(${imgMap.broker_title_bg})`,
      pagination: {
        // 翻页数据
        count: 0, // 总数量
        pageSize: 10, // 每页显示条数
        page: 1, // 当前页数
      },
      loadingFlag: false,
      dataList: [],
      dialogFlag: false,
      dialogConfirmLoading: false, // 弹窗按钮确认loading状态
      // 搜索值
      listfilter: '',
      // 当亲投票的人
      uid: '',
      uname: '',
      // 当前期数
      periods: 1,
      // 开始时间
      startTime: null,
      // 结束时间
      endTime: null,
      // 规则
      rule: '',
      // 状态 0/预热中 1:进行中 2:已结束
      voteStatus: 0,
      // 搜索开关
      searchLoaded: false,
      timer: null,
      imgMap,
      colorMap,
    };
  },
  components: {
    comPagination,
  },
  mounted() {
    this.getDataList();
  },
  computed: {
    coinList() {
      if (this.$store.state.baseData.market) {
        return this.$store.state.baseData.market.coinList;
      }
      return null;
    },
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // 弹窗确认按钮disabled
    dialogConfirmDisabled() {
      if (this.dialogConfirmLoading) {
        return true;
      }
      return false;
    },
  },
  methods: {
    // 搜索
    filterVote() {
      if (this.listfilter) {
        this.searchLoaded = true;
        this.getDataList(this.listfilter);
      } else {
        this.getDataList();
      }
    },
    voteEvent(item) {
      if (!this.isLogin) {
        this.$router.push('login');
        return;
      }
      this.uid = item.uid;
      this.uname = item.account;
      this.dialogFlag = true;
    },
    fixDFun(val, symbol) {
      if (this.showPrecision(symbol)) {
        return fixD(val, this.showPrecision(symbol));
      }
      return val;
    },
    showPrecision(symbol) {
      if (this.coinList) {
        // const { coinList } = this.$store.state.baseData.market;
        if (this.coinList[symbol]) {
          const precision = this.coinList[symbol].showPrecision;
          if (precision) {
            return precision;
          }
        }
      }
      return 4;
    },
    // 翻页事件
    pagechange(num) {
      this.pagination.page = num;
      this.getDataList();
    },
    // 获取列表数据
    getDataList(user) {
      this.dataList = [];
      this.axios({
        url: 'candidates',
        hostType: 'miningPool',
        params: {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          nextPeriodsInfoId: fixUrl('num'),
          user,
        },
        method: 'post',
      }).then(({ data, msg, code }) => {
        if (code.toString() === '0') {
          this.periods = data.periodsNum;
          this.dataList = data.list;
          this.voteStatus = Number(data.voteStatus);
          this.startTime = formatTime(data.startTime);
          this.endTime = formatTime(data.endTime);
          this.rule = data.rule;
          this.pagination.count = data.count;
        } else {
          this.$bus.$emit('tip', { text: msg, type: 'error' });
        }
        this.searchLoaded = false;
        this.loadingFlag = false;
      });
    },
    // 弹框取消
    dialogClose() {
      this.uid = '';
      this.uname = '';
      this.dialogFlag = false;
    },
    // 弹框确认
    dialogConfirm() {
      this.dialogConfirmLoading = true;
      this.axios({
        url: 'vote',
        hostType: 'miningPool',
        params: {
          uid: this.uid,
          nextPeriodsInfoId: fixUrl('num'),
        },
      }).then((data) => {
        this.uid = '';
        this.uname = '';
        this.dialogConfirmLoading = false;
        this.dialogFlag = false;
        if (data.code.toString() !== '0') {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.getDataList();
        }
      });
    },
  },
};
</script>

<style lang="stylus">
// #app {
//   background-color: #0e1a2e !important;
// }
.footer-box {
  margin-top 0;
}
.no-data {
  min-height 200px;
}
  .mining {
  margin-top: -60px;
  background-color: #0e1a2e;
  .top-content {
    padding-top 60px
    height: 220px;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: contain;
    p {
        text-align center;
        margin-top 33px;
        font-size: 22px;
        font-weight: bold;
        color: #ddd;
        line-height: 24px;
    }
  }
  .warp {
    width: 1200px;
    margin: 0 auto;
    .common-table {
      background: none;
    }
  }
  .common-loading {
    margin-top 100px;
  }
  .loading-box {
    text-align center;
  }
  .page-title {
    text-align: center;
    line-height: 50px;
    margin-top: 60px;
    font-size:30px;
  }
      .vote-search {
          margin-bottom 40px;
          .search {
              width 100%;
              height: 60px;
              background: #141E45;
              border-radius: 3px;
              box-sizing border-box;
              padding-left 50px;
              background:#fff;
              b {
                display inline-block;
                width 1px;
                height 34px;
                margin-right 46px;
                background: #2C365B;
                float: right;
                margin-top 25px;
                display: none;
              }
              button {
                height 100%;
                width 212px;
                border-radius 0 3px 3px 0;
                background: linear-gradient(32deg, #3D57C7, #21ACD4);
                color #fff;
                font-size 18px;
                line-height 60px;
                float: right;
              }
          }
            .search-input {
              line-height 60px;
              border none;
              float left;
              width 730px;
              font-size: 16px;
              color: #fff;
              input::-webkit-input-placeholder{
                color: #333A5A;
              }
              input::-moz-placeholder{   /* Mozilla Firefox 19+ */
                    color: #333A5A;
              }
              input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
                color: #333A5A;
              }
              input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
                color: #333A5A;
              }
            }
      }
  .vote-right {
      padding 32px 8px;
      box-sizing border-box;
      margin-bottom 20px;
      background: #151D41;
      border-radius: 10px;
      color: #AEB0BE;
      font-size: 22px;
      h5 {
        margin-bottom 10px;
      }
  }
  .tabel-content {
    .tabel-title {
    height: 40px;
    border-radius 3px 3px 0 0;
    background: #0472c5;
    padding-left 48px;
    padding-right 80px;
    display flex;
    justify-content space-between;
    span {
      display inline-block;
      height 100%;
      line-height 40px;
      color: #ddd;
      font-size: 16px;
    }
  }
    .tabel-item {
      padding 10px 20px 10px 48px;
      display flex;
      line-height: 50px;
      background #fff;
      display flex;
      justify-content space-between;
      .mobile {
        width 40%;
        color: #000;
        font-size: 16px;
        // display flex;
        // align-items center;
        // width: 35%;
        // span {
        //   display inline-block;
        //   width 20px;
        //   height 20px;
        //   margin-right 9px;
        //   line-height 20px;
        //   font-family: Roboto-BlackItalic;
        //   text-align: center;
        // }
      }
      .user-num {
        width 40%;
        color: #000;
        font-size: 16px;
      }
      .tabel-btn {
        width 20%;
        display flex;
        align-items center;
        justify-content: center;
      }
      .vote-btn {
        min-width: 100px;
        height: 40px;
        background: #0172C5;
        border-radius: 3px;
        padding 0 20px;
        text-align center;
        line-height 40px;
        font-size: 14px;
        color: #FFFFFF;
        margin-left:10px;
      }
    }
  }
  .pagination .pagination-bar {
    border none;
  }
  .vote-page {
    border-radius 0 0 10px 10px;
    background: #1C234A;
  }
}
</style>
